import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import ChartContainer from '@aytm/app/stats/page/question-views/components/charts/highcharts/ChartContainer'

import {
  calcLiteChartData,
  getLiteChartMode,
  LITE_CHART_MODES
} from '@aytm/app/stats/page/question-views/cjc/lib/model-data'

export { getLiteChartMode }

const LiteChart = ({
  questionId,
  questionKey,
  qType,
  answer,
  batches,
  persona,
  sortOrder,
  chartMode: chartModeProp,
  questionChartMode,
  globalChartMode,
  colorTheme,
  chartLegendMode,
  features,
  onChartModeChange,
  zoomLevel,
  globalZoomLevel,
  onZoomChange
}) => {
  const chartData = useMemo(() => calcLiteChartData({ answer, batches, persona }), [answer, batches, persona])

  const chartMode = useMemo(
    () => getLiteChartMode({ chartMode: chartModeProp, questionChartMode, globalChartMode }),
    [chartModeProp, questionChartMode, globalChartMode]
  )

  if (!chartData) return null

  return (
    <ChartContainer
      questionId={questionId}
      questionKey={questionKey}
      qType={qType}
      answerVariants={chartData.answerVariants}
      answer={chartData.synthesizedAnswer}
      sortOrder={sortOrder}
      chartMode={chartMode}
      selectorChartModeValue={chartMode}
      chartModeOverride={chartModeProp}
      globalChartMode={globalChartMode}
      chartModeTypes={LITE_CHART_MODES}
      viewOptionsDisabled={features?.view_options?.disabled}
      onChartModeChange={onChartModeChange}
      zoomLevel={zoomLevel}
      globalZoomLevel={globalZoomLevel}
      onZoomChange={onZoomChange}
      format={{}}
      rType="cases"
      zoomType={true}
      ignoreRefs={true}
      ignoreTraits={true}
      ignoreAmount={true}
      ignorePercents={false}
      colorTheme={colorTheme}
      chartLegendMode={chartLegendMode}
      features={features}
    />
  )
}

LiteChart.propTypes = {
  questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  questionKey: PropTypes.string,
  qType: PropTypes.string,
  answer: answerPropType,
  batches: PropTypes.array,
  persona: PropTypes.number,
  sortOrder: PropTypes.string,
  chartMode: PropTypes.string,
  questionChartMode: PropTypes.string,
  globalChartMode: PropTypes.string,
  colorTheme: PropTypes.array,
  chartLegendMode: PropTypes.string,
  features: PropTypes.object,
  onChartModeChange: PropTypes.func,
  zoomLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  globalZoomLevel: PropTypes.string,
  onZoomChange: PropTypes.func
}

LiteChart.defaultProps = {
  persona: 0,
  sortOrder: 'iasc'
}

LiteChart.displayName = 'ConjointLiteChart'

export default LiteChart
